import axios from 'axios';

const deleteTeamDefaultContact = async (teamId: string, contactId: string) => {
  const { data } = await axios.request({
    url: `/team/default/contact/${teamId}/${contactId}`,
    method: 'post',
  });

  return data;
};

export default deleteTeamDefaultContact;
